import { getApiConfig } from "@/config/api.config";
import { BaseApiService } from "@/services/api/BaseApiService";
import { MobileLink } from "@/types/mobileLink";

class MobileLinkService extends BaseApiService {
  constructor() {
    super();
  }

  async getById(id: number): Promise<MobileLink> {
    const response = await this.get<{ data: MobileLink }>(`/weblink/${id}`, this.getCoreBaseUrl());
    return response.data;
  }

  async getByStoreId(storeId: number): Promise<MobileLink[]> {
    const response = await this.get<{ data: MobileLink[] }>(
      `/weblink/store/${storeId}`,
      this.getCoreBaseUrl(),
    );
    return response.data;
  }

  async getByCustomerId(customerId: number): Promise<MobileLink[]> {
    const response = await this.get<{ data: MobileLink[] }>(
      `/weblink/customer/${customerId}`,
      this.getCoreBaseUrl(),
    );
    return response.data;
  }

  async create(data: MobileLink): Promise<MobileLink> {
    const response = await this.post<{ data: MobileLink }>("/weblink", data, this.getCoreBaseUrl());
    return response.data;
  }

  async update(data: MobileLink): Promise<MobileLink> {
    const response = await this.put<{ data: MobileLink }>("/weblink", data, this.getCoreBaseUrl());
    return response.data;
  }

  private getCoreBaseUrl(): string {
    return getApiConfig().core;
  }
}

export default new MobileLinkService();
